import { render, staticRenderFns } from "./MetaPlatformIcon.vue?vue&type=template&id=cf04c632&scoped=true"
import script from "./MetaPlatformIcon.vue?vue&type=script&lang=js"
export * from "./MetaPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf04c632",
  null
  
)

export default component.exports